'use client';

import dynamic from 'next/dynamic';

import { DateSelectorSkeleton } from '../skeleton';
import type { BookingViewProps } from './booking-view';

const LazyBookingViewInner = dynamic(
  () =>
    import('./booking-view-with-provider').then(mod => ({
      default: mod.BookingViewWithProvider,
    })),
  {
    ssr: true,
    loading: () => <DateSelectorSkeleton />,
  },
);

export function LazyBookingView(props: BookingViewProps) {
  return <LazyBookingViewInner {...props} />;
}
